import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import {  ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CardServiceService } from '../Services/card-service.service';
import { CookieService } from '../Services/cookie';

@Component({
  selector: 'app-stop-card',
  templateUrl: './stop-card.component.html',
  standalone:false,
  styleUrls: ['./stop-card.component.scss']

})

export class StopCardComponent  implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  ReasonsList:[];
  
  selectedReasonid:string='';
  internalId
  selectedReason:string=''
  

  constructor(private route:ActivatedRoute, private cookieService:CookieService,private location: Location,private auth:AuthService,private commonP:CommonService,private _router:Router,private cardService:CardServiceService) { }
  back() {
    this.location.back()
  }
  async ngOnInit():Promise<void> {

    this.route.queryParams.subscribe(params => {
      if(params['id']){

        this.internalId=params['id'];
      }

    });

    this.auth.accessToken = await this.commonP.Get("token");
    await this.commonP.presentLoading();
    
    this.auth.VerifyToken({}, this.auth.accessToken).then(async (data: any) => {
      if (data.response) {
        if (data.response.code) {
          if (data.response.code == 1) {
            this.auth.GetFieldValues("SRC",this.auth.accessToken).then((data:any)=>{
              if(data?.response?.code==1){
                this.commonP.hideLoading();
                let ReasonsList =data?.response?.content?.list?.SRC;

                this.ReasonsList=ReasonsList.map(x=>({
                 value:x.strCode,
                 displayValue:x.labelEn

                }))

        }else{
                
                this.commonP.hideLoading();
                this.commonP.ParseErrorAlert('', '', this._router, data);
              }
          
          
          
            })
  
          } else {
            await this.commonP.hideLoading();
            this.commonP.ParseErrorAlert("", "", this._router, data);
          }
        } else {
          await this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "", this._router, data);
        }
      } else {
        await this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("", "", this._router, data);
      }
    });
   


  }
  Reason(reasonid,value){
  
    
this.selectedReason=value
this.selectedReasonid=reasonid;


  }
  UpdateCardStatus(){
    
    let body={
      InternalId:this.internalId,
      Status:'STOP',
      StopReasonCode:this.selectedReasonid

    }
    this.commonP.presentLoading();
    this.cardService.UpdateCardStatus(body,this.auth.accessToken).then((data:any)=>{
      if(data?.response?.code==1){
        
        if(data.response.content.status){

          this.commonP.hideLoading();

          this.cookieService.set("flow", 'StopCard',true);
         this._router.navigateByUrl("/PayCardSuccess");

        }else{
          
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert('', '', this._router, data);
        }      
      }else{
        
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('', '', this._router, data);
      }
  
  
  
    })

  }
isValid(){
  if(this.selectedReasonid){
    return false
  }else{
    return true
  }
}  

showModal(num) {
    this.modalObservable.next(num);
  }


}

